import React from 'react';

import {
  t,
} from '../../helpers';

const About = () => (
  <section id="about" className="content-section text-center">
    <div className="container">
      <div className="row">
        <div className="col-lg-8 mx-auto">
          <h2>{t('about.title')}</h2>
          <p>{t('about.text')}</p>
          <p>{t('about.text2')}</p>
        </div>
      </div>
    </div>
  </section>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About/index.js